<template>
  <box-folding
    v-model="filter.isOpen"
    :counter="selectedQty"
    class="filter-folding"
    :title="title"
    v-bind="$attrs"
    :class="{
      [`type-${type}`]: true,
    }"
  >
    <slot name="before" />

    <slot name="default">
      <ul
        v-if="type === 'checkbox'"
        class="list-checkbox"
        :style="listStyle"
      >
        <li
          v-for="(item, index) in filterData"
          :key="index"
          class="list-checkbox__item"
          :style="itemStyle"
        >
          <form-checkbox
            v-model="item.checked"
            :name="item.name"
            class="list-checkbox__control"
          >
            {{ item.label }}
          </form-checkbox>
        </li>
      </ul>

      <form-slider
        v-if="type === 'slider'"
        v-model="filter.slider.value"
        :min="filter.slider.min"
        :max="filter.slider.max"
        :units="filter.slider.units || 'mi'"
        :units-position="filter.slider.unitsPosition || 'post'"
        :value-position="filter.slider.valuePosition || 'top'"
        :value-color="filter.slider.valueColor || '#8fb6f5'"
      >
        <template
          v-if="filter.slider.leftLabel"
          #left-label
        >
          {{ filter.slider.leftLabel }}
        </template>
        <template
          v-if="filter.slider.rightLabel"
          #right-label
        >
          {{ filter.slider.rightLabel }}
        </template>
        <template
          v-if="filter.slider.getValueLabel"
          #value
        >
          {{ filter.slider.getValueLabel() }}
        </template>
      </form-slider>

      <div v-if="type === 'select'">
        <multiselect
          v-model="filter.selectValue"
          class="filter-folding__select select-filters"
          track-by="id"
          label="label"
          :options="filter.selectOptions"
          hide-selected
          :searchable="false"
          :allow-empty="false"
          :show-labels="false"
        />
      </div>
    </slot>

    <slot name="after" />
  </box-folding>
</template>

<script>
export default {
  name: 'filter-folding',
  props: {
    filter: {
      type: Object,
      default() {
        return {};
      },
    },
    initialState: {
      type: Boolean,
      default: true,
    },
    type: {
      validator: function (value) {
        return ['checkbox', 'slider', 'select'].includes(value) || value === null || value === undefined;
      },
      default: null,
    },
    title: {
      type: String,
      required: true,
    },
    listStyle: {
      type: Object,
      default: null,
    },
    itemStyle: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      filterData: this.filter.data,
    };
  },
  computed: {
    selectedQty() {
      if (this.type === 'checkbox') {
        const qty = this.filterData.reduce((acc, item) => acc + +item.checked, 0);
        return qty > 0 ? `+${qty}` : 0;
      }
      return null;
    },
  },
  created() {
    if (this.type !== 'checkbox' || this.initialState) {
      this.filterData = this.filter.data;
    }
    if (this.type === 'checkbox' && !this.initialState) {
      this.filterData = this.filter.data.map(item => ({
        ...item,
        checked: false,
      }));
    }
  },
};
</script>

<style lang="scss">
.filter-folding {
  &__select {
    width: auto;
    display: inline-block;
  }
  .box-folding__content-holder {
    & > * ~ * {margin-top: 10px;}
  }
}
.select-filters {
  &.multiselect {
    min-height: 0;
    cursor: pointer;
  }
  .multiselect {
    &__tags {
      border: none;
      background-color: #fff;
      padding: 0;
      border-radius: 3px;
      min-height: 0;
      font-size: 14px;
      font-weight: bold;
      color: #6e7c91;
      line-height: 16px;
      $height: 30px;
      padding: 7px 11px;
    }
    &__select {
      width: 30px;
      height: 100%;
      right: 0;
      padding: 0;
      top: 0;
      bottom: 0;
      &:before {
        display: none;
      }
      &:after {
        content: '';
        background-image: url('/icons/icon-arrow-down.svg');
        background-size: contain;
        width: 10px;
        height: 6px;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }
    }
    &__single {
      background: none;
      line-height: inherit;
      padding: 0;
      margin: 0;
      min-height: 0;
      text-overflow: ellipsis;
      overflow: hidden;
      padding-right: 22px;
    }
    &__content-wrapper {
      min-width: 100%;
      width: auto;
    }
  }
}
</style>
